module.exports = __webpack_public_path__ + "img/map-2.c33d676b.png";